<template>
  <div class="space-y-6 text-center">
    <div
      v-if="!props.paymentSuccessful"
      class="space-y-6"
    >
      <div
        v-if="!props.cancellationPending"
        class="text-sm text-gray-500 mb-2"
      >
        {{ $t('REGISTER.PAYMENT_SUBTITLE') }}
      </div>

      <el-alert
        v-if="props.cancellationPending"
        type="warning"
        :closable="false"
        :title="$t('PAYMENT_REMINDER.PAYMENT_CANCELLATION_PENDING_TITLE')"
        :description="$t('PAYMENT_REMINDER.PAYMENT_CANCELLATION_PENDING_DESCRIPTION', {
          seconds: props.cancellationRemainingSeconds,
        })"
        show-icon
      />

      <PaymentInfoDisplay
        v-else
        :payment-info="props.paymentInfo"
        :amount="props.orderDetails?.amount || 0"
        :package-name="props.orderDetails?.packageName"
        :credits="props.orderDetails?.credits"
      />

      <el-alert
        v-if="props.refreshLoading"
        type="info"
        :closable="false"
        :title="$t('PAYMENT_REMINDER.PAYMENT_FULFILLMENT_CHECKING')"
        show-icon
      />

      <div
        v-if="!props.cancellationPending"
        class="flex items-center justify-center gap-2 text-primary-500 font-medium animate-pulse"
      >
        <base-loader :size="16" />
        <span>{{ $t('REGISTER.WAITING_PAYMENT') }}</span>
      </div>
    </div>

    <div
      v-else
      class="space-y-4 py-8"
    >
      <div class="w-16 h-16 bg-success/10 rounded-full flex items-center justify-center mx-auto text-success text-3xl">
        ✓
      </div>
      <h2 class="text-xl font-bold text-success">
        {{ $t('REGISTER.PAYMENT_SUCCESS') }}
      </h2>
    </div>
  </div>
</template>

<script setup lang="ts">
type PropsType = {
  orderDetails: any;
  paymentInfo: any;
  paymentSuccessful: boolean;
  refreshLoading: boolean;
  cancellationPending: boolean;
  cancellationRemainingSeconds: number;
};

const props = defineProps<PropsType>();
</script>
